import type { HapticsPort } from '../types';

/** Web haptics: short `navigator.vibrate` pulses where supported (Android Chrome); a no-op on iOS Safari. */
export function createWebHaptics(nav: Navigator = navigator): HapticsPort {
  let enabled = true;
  const vibrate = (pattern: number | number[]) => {
    if (!enabled || typeof nav.vibrate !== 'function') return;
    try {
      nav.vibrate(pattern);
    } catch {
      // Some browsers throw when called without a user gesture; haptics are best-effort.
    }
  };
  return {
    impact: (style) => {
      vibrate(style === 'light' ? 10 : 20);
    },
    selection: () => {
      vibrate(6);
    },
    success: () => {
      vibrate([12, 40, 18]);
    },
    setEnabled: (value) => {
      enabled = value;
    },
  };
}
